import { render } from "./ConfigurationTeam.vue?vue&type=template&id=e64f883c&scoped=true"
import script from "./ConfigurationTeam.vue?vue&type=script&lang=js"
export * from "./ConfigurationTeam.vue?vue&type=script&lang=js"

import "./ConfigurationTeam.vue?vue&type=style&index=0&id=e64f883c&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64f883c"]])

export default __exports__